const state = {
  tripFilter: {
    source: null,
    destination: null,
    vehicleNumber: null,
    status: null,
    page: 1,
  },
  trips: [],
  trackLoadingStatus: false,
  trackFormLoading: false,
  tripPagination: false,
  showLoading: false,
  tripDetails: [],
  trackMeta: {},
};

export default state;
